import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ThemeContextProvider } from "./context/ThemeContext"
import { ModalContextProvider } from "./context/ModalContext"
import { AccessibilityProvider } from "./context/AccessibilityContext"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <QueryClientProvider client={new QueryClient()}>
                <ThemeContextProvider>
                    <AccessibilityProvider>
                        <ModalContextProvider>
                            <App />
                        </ModalContextProvider>
                    </AccessibilityProvider>
                </ThemeContextProvider>
            </QueryClientProvider>
        </BrowserRouter>
    </React.StrictMode>
)

reportWebVitals()
